import { wmfetch } from "@/helpers/wmfetch"; //引用fetch.js

export function getInfos(data) {
  return wmfetch({
    url: '/api/getDataFromThirdPart',
    method: 'get',
    params: data
  })
}
export function getCode(data) {
  return wmfetch({
    url: '/api/wechat',
    method: 'get',
    params: data
  })
}
/**
 * desc  备注
 * handleStatus 4.已约谈整改 5.已上报线索 6.已关停站点 3.反馈
 * data  违规信息集合
 * data.violationType 违规信息类型 （固定表述错误:1；涉黄:2；历史虚无:6；专项行动:7；违规账号:11; 网站扫描：12）
 * data.id 违规信息id
 * data.publishTime 发布时间
*/
export function handleViolation(data) {
  return wmfetch({
    url: '/api/handleViolation',
    method: 'put',
    data: data
  })
}